module.exports = __webpack_public_path__ + "static/img/TestImage.72b35d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/listings/custom/TestImage.jpg
// module id = Rqaw
// module chunks = 0